<template>
  <div>
    <ctlHomeNav></ctlHomeNav>
    <v-container class="mt-1">

      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-flex>
      </v-layout>
      <v-form ref="quoteform" v-model="formValid" lazy-validation>
        <v-card class="mx-auto" style>
          <v-toolbar color="secondary accent-1" cards dark flat>
            <v-card-title class="title font-weight-regular">{{title}}</v-card-title>
          </v-toolbar>
          <ctlQuoteEdit :quoteData="quoteData"></ctlQuoteEdit>
          <!-- <v-card-text>
            <ctlQuoteItems :quoteData="quoteData"></ctlQuoteItems>
          </v-card-text> -->
          <v-flex xs-12 pt-3 class="text-xs-center">
            <v-btn color="primary" :disabled="!formValid" @click="onSaveQuote">{{isNew? "Add Items" : "Save"}}</v-btn>
            <!-- <v-btn @click="clear">clear</v-btn> -->
          </v-flex>
        </v-card>
      </v-form>
      <!-- <div>
                <v-btn color="primary" fab small dark
                    @click.prevent="showCustomerPicker = true">
                    <v-icon>search</v-icon>
                </v-btn>
            </div>
            <v-dialog v-model="showCustomerPicker"
                width="">
                <on="onFacilityPicked"></ctlCustomerPicker>
      </v-dialog>-->
      <div>

      </div>
      <!-- <v-dialog v-model="showFacilityPicker" width="500" height="400">
        <ctlFacilitySearch @onPicked="onFacilityPicked"></ctlFacilitySearch>
      </v-dialog> -->
    </v-container>
    <!-- {{quoteData}} -->
  </div>
</template>
<script>
// import ctlCustomerPicker from '@/components/ctlCustomerPicker'
// import ctlFacilitySearch from "@/components/ctlFacilitySearch";
// import ctlQuoteItems from "@/components/public/ctlQuoteItems";
import ctlQuoteEdit from "@/components/public/ctlQuoteEdit";
import ctlHomeNav from '@/components/ctlHomeNav'
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ctlQuoteEdit: ctlQuoteEdit,
    // ctlFacilitySearch: ctlFacilitySearch,
    ctlHomeNav: ctlHomeNav
  },
  data: () => ({
    quoteData: {
      basicInfo: {
        facilityShipMethod: {}
      },
      items: []
    },
    // showCustomerPicker: false,
    showFacilityPicker: false,
    formValid: false,
    rules: {
      required: v => !!v || "This field is required"
    }
  }),
  computed: {
    ...mapGetters("auth", [
      "loggedIn",
      "userHasInternalRole",
      'userHasSalesQuoteManagerRole',
    ]),
    id() {
      return this.$route.params.id;
    },
    isNew() {
      return !this.id;
    },
    title() {
      return this.isNew ? "Create New Quote" : "Edit Quote";
    },
    error() {
      return this.$store.getters.error;
    },
    // wrappedQuoteData() {
    //   return {quoteData: this.quoteData}
    // }
  },
  watch: {},
  methods: {
      ...mapActions('pubQuoteEdit', [
          'saveSalesRepQuote',
          'populateNewQuote',
          'populateQuoteEditDataForSalesRep',
      ]),
      // ...mapActions('customerSearch', [
      //     'getFacilityDataById'
      // ]),
    async onSaveQuote () {
      // console.log('jobTypeId' + jobTypeId)
      if (!this.$refs.quoteform.validate()) {
        alert('Please fixes invalid fields befor you submit')
        return
      }
      // if(this.quoteData.items.length === 0) {
      //   alert('Please add Item before you submit')
      //   return
      // }
      try {
        const resp = await this.saveSalesRepQuote(this.quoteData);
        // this.$emit("commiBatchSaved", resp.id);
        if(this.userHasInternalRole) {
          this.$router.push({ name: 'int-quote-board', params: { id: resp.id } })
        }
        //20200625, add for International Territory Rep
        else if(this.userHasSalesQuoteManagerRole){
            this.$router.push({ name: 'int-quote-board', params: { id: resp.id } })
        }
        else {
          this.$router.push({ name: 'pub-quote-board', params: { id: resp.id } })
        }
      } catch (e) {
        // Save failed - stay on current page and show error to user.
        var errorMsg = (e.response && e.response.data) ? e.response.data : e.message
        alert('Save quote failed: ' + errorMsg)
      }
    },
    // get the facility data based on facility id
    async populateFacilityData (id) {
        
    },
    // async onFacilityPicked(id) {
    //   console.log(`"onFacilityPicked, id=${id}"`);
    //   this.showFacilityPicker = false
    //   var facilityData = await this.getFacilityDataById({id})

    //   this.quoteData = Object.assign({}, this.quoteData, facilityData)
    // },
    // onBasicQuoteDataChanged(updateQuoteData) {
    //   this.quoteData = Object.assign({}, this.quoteData, updateQuoteData)
    // },
    onDismissed() {
      // console.log('onDismissed alert')
      // this.$store.dispatch('clearError')
    }
  },
  created: async function() {
    if(this.id) {
      this.quoteData = await this.populateQuoteEditDataForSalesRep(this.id)
    } else {
      this.quoteData = await this.populateNewQuote()
    }


  },
  mounted: function() {},
  destroyed: function() {
    this.onDismissed();
  }
};
</script>